module.exports = "<svg viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M16 6c4.838 0 8.873 3.436 9.8 8h1.7a.5.5 0 01.5.5v3a.5.5 0 01-.5.5l-1.7.001C24.873 22.565 20.838 26 16 26s-8.873-3.435-9.8-7.999L4.5 18a.5.5 0 01-.5-.5v-3a.5.5 0 01.5-.5h1.7c.927-4.564 4.962-8 9.8-8zm7.748 12H8.252a8.003 8.003 0 0015.496 0zM16 8a8.003 8.003 0 00-7.748 6h15.496c-.888-3.45-4.02-6-7.748-6z\" fill=\"#3d3d3d\" class=\"asda-icon__draw\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./common/components/icon/system/asda-tube.svg
// module id = 710
// module chunks = 0